module.exports = __webpack_public_path__ + "img/arrow_down_grey.77ad0694.svg";